import configuratorReducer from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer";
import { SET_INITIAL_STATE } from "@configuratorware/configurator-frontendgui/App/Reducers/GeneralActions.js";
import { RECEIVE_CONFIGURATION } from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import {
  APP_RECEIVE_COMPONENT_FILTERS,
  APP_REMOVE_EMBROIDERY_CUSTOM_DATA,
  APP_SET_ACTIVE_COMPONENT_FILTER,
  APP_SET_CUSTOM_DATA
} from "./Actions/action-types";
import { SetCustomDataArgs } from "../Types";
import { get, isArray } from "lodash";

export default (state, action) => {
  const newState = configuratorReducer(state, action);
  const { type, payload, field, data, source } = action;

  switch (type) {
    case SET_INITIAL_STATE: {
      return {
        ...newState,
        calculationIsEnabled: false,
        selectedComponentFilters: [],
        activeComponentFilter: null,
        filteredComponentIdentifier: null
      };
    }

    case RECEIVE_CONFIGURATION: {

      const loadedByCode = !!state.loadCode;

      const customdata = loadedByCode
        ? newState.configuration.customdata
        : {
          ...newState.configuration.customdata,
          userValues: {
            ...newState.configuration.customdata?.userValues,
            ...state.configuration.customdata?.userValues
          }
        };

      return {
        ...newState,
        configuration: {
          ...newState.configuration,
          customdata,
        },
      };
    }

    case APP_SET_CUSTOM_DATA: {
      return {
        ...newState,
        configuration: {
          ...newState.configuration,
          customdata: {
            textFontFamily: "Holli",
            textColor: null,
            displayName: "",
            displayPhone: "",
            ...newState.configuration.customdata,
            ...payload,
          } as SetCustomDataArgs,
        },
      };
      break;
    }

    case APP_REMOVE_EMBROIDERY_CUSTOM_DATA: {
      let customData = {...newState.configuration.customdata};
      try {
        delete customData.textFontFamily;
        delete customData.textColor;
        delete customData.displayName;
        delete customData.displayPhone;
      } catch (e) {}
      return {
        ...newState,
        configuration: {
          ...newState.configuration,
          customdata: {
            ...customData
          } as SetCustomDataArgs,
        },
      };
      break;
    }

    case APP_RECEIVE_COMPONENT_FILTERS: {
      const activeComponentFilter = isArray(payload.filters) && payload.filters.length > 0 ? get(payload.filters[0], 'identifier') : null;
      const filteredComponentIdentifier = payload.filteredComponentIdentifier;
      return {
        ...newState,
        selectedComponentFilters: payload.filters,
        activeComponentFilter,
        filteredComponentIdentifier,
      };
      break;
    }

    case APP_SET_ACTIVE_COMPONENT_FILTER: {
      return {
        ...newState,
        activeComponentFilter: payload
      };
      break;
    }

    default:
      return newState;
  }
};
